// export default {
//     serverURL: 'http://localhost:8000',
//     api: 'http://localhost:8000/graphql',
//     defaultLang: 'vn',
//     publicPath: '/',
// }
export default {
    serverURL:   'https://comaygao.com',
    api:         'https://comaygao.com/graphql',
    defaultLang: 'vn',
}

/*export default {
    serverURL:   'https://rice.comayautomation.com',
    api:         'https://rice.comayautomation.com/graphql',
    defaultLang: 'vn',
}*/


